import useCloudPermissions from "hooks/useCloudPermissions";
import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import { useAtomValue } from "jotai";
import { IsMobileAtom } from "../../App";
import { useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { Button } from "reactstrap";
import { Whisper, Popover } from "rsuite";
import PopoverDropdownMenu from "components/Menus/PopoverDropdownMenu";
import DropdownMenuDivider from "components/Menus/DropdownMenuDivider";

const DataSource = ({
  module,
  isVisible,
  disabled = false,
  setExportDrawer,
  availableOptions = [
    "ViewData",
    "ExportData",
    "ChangeDataSource",
    "ManageDataSource",
    "TableSettings",
  ],
  tableSettingsDisabled = false,
  toggleTableSettings,
  viewMode = "Table",
}) => {
  const { tenantID } = useParams();
  const dataSourceWhisperRef = useRef();
  const { cPermissions } = useCloudPermissions();
  const mobileScreen = useAtomValue(IsMobileAtom);

  const options = [
    {
      key: "ViewData",
      name: `View All ${module?.Name}`,
      icon: "mdi mdi-database-search",
      disabled: !cPermissions.cloud_modify_module,
      divider: false,
      link: `/clouds/${tenantID}/records/${module?.APIName}`,
    },
    {
      key: "TableSettings",
      name: "Table Settings",
      icon: "mdi mdi-table",
      disabled: tableSettingsDisabled,
      divider: false,
      onClick: toggleTableSettings,
    },
    {
      key: "ExportData",
      name: "Export Data",
      onClick: () => {
        dataSourceWhisperRef.current.close();
        setExportDrawer(true);
      },
      icon: "mdi mdi-export-variant",
      disabled: !cPermissions.cloud_get_records,
      divider: false,
    },
    {
      key: "ManageDataSource",
      name: "Manage Data Source",
      icon: "mdi mdi-database-cog",
      disabled: !cPermissions.cloud_modify_module,
      divider: true,
      link: `/clouds/${tenantID}/settings/modules/manage/${module?.APIName}/fields`,
    },
  ];

  const optionsSelected = options.filter((item) =>
    availableOptions.includes(item.key)
  );

  const ModuleSettingsOptions = () => {
    return (
      <PopoverDropdownMenu>
        <h5 className="px-2 pt-2 text-dark">
          <i className="mdi mdi-database pr-2"></i>Data Source
        </h5>
        <DropdownMenuDivider></DropdownMenuDivider>
        {optionsSelected.map((option) => {
          const Option = (
            <>
              {option.divider && <DropdownMenuDivider />}
              <DropdownOptionWithIcon
                name={option.name}
                onClick={option.onClick}
                icon={option.icon}
                disabled={option.disabled}
              />
            </>
          );

          if (option.link) {
            return (
              <Link key={option.key} to={option.link}>
                {Option}
              </Link>
            );
          }

          return <div key={option.key}>{Option}</div>;
        })}
      </PopoverDropdownMenu>
    );
  };

  return (
    <Whisper
      placement="autoVerticalEnd"
      trigger="click"
      speaker={
        <Popover
          className="sidebar-popover"
          full
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <ModuleSettingsOptions />
        </Popover>
      }
      controlId="dataSourceWhisper"
      ref={dataSourceWhisperRef}
    >
      <Button
        size="sm"
        color="secondary"
        outline
        disabled={disabled}
        className="d-flex justify-content-center align-items-center"
        style={{
          width: mobileScreen ? 24 : "",
          height: mobileScreen ? 24 : "",
        }}
      >
        <i
          className={`mdi mdi-database-outline ${
            isVisible && "pr-0 mr-0 mr-lg-1 pr-lg-1"
          }`}
          style={{
            fontSize: mobileScreen ? 20 : 16,
          }}
        ></i>
        {isVisible && (
          <span className="d-none d-lg-inline text-nowrap">{module?.Name}</span>
        )}
      </Button>
    </Whisper>
  );
};

export default DataSource;
